import { useEffect } from 'react'
import { useUser } from './useUser'
import { useNavigate } from 'react-router-dom'
import { isInternalUser } from '@fable/utils'

export const useInternalOnly = () => {
  const navigate = useNavigate()
  const { user, loading } = useUser()

  useEffect(() => {
    if (!loading) {
      if (!isInternalUser(user)) {
        navigate('/404')
      }
    }
  }, [loading, user, navigate])
}
